module.exports = __webpack_public_path__ + "static/media/stop.7cd1c133.svg";